export default __webpack_public_path__ + "static/media/Blog12.14.ad2848cd.png";